const articleSharing = () => {
    if ( ! navigator.canShare ) {
		return;
	}
    const articleShare = document.querySelector('ul.social-share');
    if ( ! articleShare ) {
		return;
	}

	const articleHeader = document.querySelector('h1.entry-title');
    const articleContent = document.querySelector('.entry-content p:first-of-type');

    const articleLinkShareBtn = articleShare.querySelector('li a.social.link');
    const articleSocialShareBtns = articleShare.querySelectorAll('li a.social:not(.link)');

	const shareData = {
		title: articleHeader.textContent,
		text: articleContent.textContent || '',
		url: window.location.href,
	};

	// Display the share button if supported in browser
	articleLinkShareBtn.parentElement.hidden = false;

	// Hide social share buttons
	articleSocialShareBtns.forEach(link => {
		link.parentElement.hidden = true;
	});

	articleLinkShareBtn.addEventListener('click', async (e) => {
		e.preventDefault();
		await navigator.share(shareData);
	});

}

export { articleSharing };
